import { render, staticRenderFns } from "./DetallesDelPlan.vue?vue&type=template&id=79e04a18&scoped=true"
import script from "./DetallesDelPlan.vue?vue&type=script&lang=js"
export * from "./DetallesDelPlan.vue?vue&type=script&lang=js"
import style0 from "./DetallesDelPlan.vue?vue&type=style&index=0&id=79e04a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e04a18",
  null
  
)

export default component.exports